import React from "react";
import { Link } from "react-router-dom";
import "../Styles/LaunchPadCallout.css";

const LaunchPad = () => {
  return (
    <div className="launchpad-page">
      <div className="launchpad-top">
        <Link to="/" className="btn btn-secondary launchpad-back">
          ← Back to True Bloom
        </Link>
      </div>

      <section className="launchpad-hero">
        <p className="eyebrow" style={{ color: "#b7e09a" }}>
          True Bloom LaunchPad
        </p>
        <h1>Train to tutor. Earn on your schedule.</h1>
        <p>
          LaunchPad is our selective training and hiring path for university students who want
          meaningful, flexible work that pays well and builds real skills.
        </p>
        <a
          href="https://docs.google.com/forms/d/e/1FAIpQLSeZh_WpoxKcxPMdL1tPXxpNsPotkL1uS4yAtUkctJE3UlvXLg/viewform?usp=dialog"
          className="btn btn-primary"
          target="_blank"
          rel="noopener noreferrer"
          style={{ background: "white", color: "#1e4d2b", boxShadow: "none" }}
        >
          Apply Now
        </a>
      </section>

      <section className="launchpad-callout" id="launchpad">
        <div className="launchpad-callout-wrapper">
          <div className="launchpad-callout-button-container">
            <a
              href="https://docs.google.com/forms/d/e/1FAIpQLSeZh_WpoxKcxPMdL1tPXxpNsPotkL1uS4yAtUkctJE3UlvXLg/viewform?usp=dialog"
              className="launchpad-callout-button"
              target="_blank"
              rel="noopener noreferrer"
            >
              Apply Now
            </a>
          </div>

          <div className="launchpad-callout-container">
            <div className="launchpad-callout-content">
              <h2>Why should you apply?</h2>
              <p>
                Tutoring lets you earn great money on your own schedule while building communication,
                organization, and independence — skills that matter beyond school.
              </p>
              <p>
                We only bring on students who are sharp, dependable, and serious about quality work.
                From there, we show you how to tutor well: connect with students, teach clearly, and
                deliver consistent results.
              </p>
              <p className="highlight">
                If you take pride in helping others and want flexible, meaningful work that looks
                strong on a resume, this is the place to start.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default LaunchPad;
